const notificationEventType = Object.freeze({
    RESERVATION_CREATED: 'reservation-created',
    RESERVATION_UPDATED: 'reservation-updated',
    RESERVATION_REQUEST: 'reservation-request',
    RESERVATION_CANCELLED: 'reservation-cancelled',
    NEW_FEATURE_AVAILABLE: 'new-feature-available',
    OTA_CONNECTION_ERROR: 'ota-connection-error',
    BEEHAZ_ERROR: 'beehaz-error',
    DOUBLE_BOOKING: 'double-booking',
    CHANGE_OF_GUEST_DETAILS: 'change-of-guest-details',
    RENTAL_NOT_FOUND_TO_CREATE_RESERVATION: 'rental-not-found-to-create-reservation',
    RENTAL_NOT_FOUND_TO_UPDATE_RESERVATION: 'rental-not-found-to-update-reservation',
    RENTAL_NOT_FOUND_TO_DELETE_RESERVATION: 'rental-not-found-to-delete-reservation',
    RENTAL_NOT_FOUND_TO_REQUEST_RESERVATION: 'rental-not-found-to-request-reservation',
    RESERVATION_NOT_FOUND_TO_UPDATE_RESERVATION: 'reservation-not-found-to-update-reservation',
    RESERVATION_NOT_FOUND_TO_DELETE_RESERVATION: 'reservation-not-found-to-delete-reservation',
    BEEHAZ_SETTINGS_DIFFER_FROM_OTA: "beehaz-settings-differ-from-ota",
    USER_CHANGED_EMAIL_OR_ACCOUNT_TYPE: "user-changed-email-or-account-type",
});

export default notificationEventType;